export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/kaitlynfujihara/Desktop/keiken/src/environments/environment.ts